import * as React from "react";
import C from "classnames";
export const ModalBody = (props) => {
    return (React.createElement("div", { className: C("modal-body", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=ModalBody.js.map